import { render } from "./AppSponsorët.vue?vue&type=template&id=094d821f"
import script from "./AppSponsorët.vue?vue&type=script&lang=js"
export * from "./AppSponsorët.vue?vue&type=script&lang=js"

import "./AppSponsorët.vue?vue&type=style&index=0&id=094d821f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__